<template>
  <v-layout align-center>
    <v-flex>
      <v-menu
        ref="menu"
        :close-on-content-click="false"
        v-model="menu2"
        :nudge-right="40"
        :return-value.sync="time"
        format="ampm"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <v-text-field style="padding: 0px!important;margin: 0px!important;"
          slot="activator"
          v-model="time"
          placeholder="Select time"
        ></v-text-field>
        <v-time-picker
          v-if="menu2"
          v-model="time"
          format="ampm"
          full-width
          @change="$refs.menu.save(time)"
        ></v-time-picker>
      </v-menu>
    </v-flex>
  </v-layout>

</template>
<script>
  export default {
    data () {
      return {
        time: null,
        menu2: false,
        modal2: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/TimePicker.vue